<div class="sidebar-footer" />

<style lang="scss">
  .sidebar-footer {
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    padding: 10px 0px;
    margin: 0px 20px;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
  }
</style>
